import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtGetListForSelect(params) {
  return request(
    `${BASE_URL}/provider/ams/partner/listForSelect`,
    METHOD.GET,
    params
  )
}

export async function rqtPostPartnerQuery(params) {
  return request(
    `${BASE_URL}/provider/ams/partner/query`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostPartnerQueryCount(params) {
  return request(
    `${BASE_URL}/provider/ams/partner/query/count`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtDeletePartner(id, params) {
  return request(
    `${BASE_URL}/provider/ams/partner/${id}`,
    METHOD.DELETE_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostPartner(params) {
  return request(
    `${BASE_URL}/provider/ams/partner/`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetPartner(id, params) {
  return request(`${BASE_URL}/provider/ams/partner/${id}`, METHOD.GET, params)
}

export async function rqtPutPartner(params) {
  return request(
    `${BASE_URL}/provider/ams/partner`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}
